import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Apple: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6117 2.14388C7.82611 1.95204 8.17373 1.95204 8.38813 2.14388L12.5058 5.82809C12.7202 6.01992 12.7202 6.33095 12.5058 6.52279C12.2914 6.71463 11.9438 6.71463 11.7294 6.52279L7.99992 3.18593L4.27049 6.52279C4.05608 6.71463 3.70846 6.71463 3.49406 6.52279C3.27965 6.33095 3.27965 6.01992 3.49406 5.82809L7.6117 2.14388Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49406 9.47713C3.70846 9.28529 4.05608 9.28529 4.27049 9.47713L7.99992 12.814L11.7294 9.47713C11.9438 9.28529 12.2914 9.28529 12.5058 9.47713C12.7202 9.66897 12.7202 9.97999 12.5058 10.1718L8.38813 13.856C8.17373 14.0479 7.82611 14.0479 7.6117 13.856L3.49406 10.1718C3.27965 9.97999 3.27965 9.66897 3.49406 9.47713Z"
        fill="#F7F7F7"
      />
    </svg>
  );
};

export default Apple;
